<template>
  <div class="event-block">
    <p style="margin-bottom: 4px;">
      <small>{{ event.name }}</small>
    </p>
    <p style="margin-bottom: 4px;">
      {{ event.displayDate }}
    </p>
    <p style="margin-bottom: 0px;">
      <em>
        <small>{{ event.groups }}</small>
      </em>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Event',

  props: {
    event: {
      required: true,
    },
  },

  data () {
    return {}
  },

  computed: {},

  mounted () {
  },
}
</script>

<style>
</style>
